import { getDesksState } from '../utils';

export const selectActiveIndex = (state) => getDesksState(state).activeIndex;
